import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

declare var $

export class AnnotatedVideo {
  el: typeof $
  video: HTMLMediaElement
  currentVideoUrl: string
  annotationCount: number

  constructor(el) {
    this.el = $(el)
    this.video = $('video', el).get(0)
    this.currentVideoUrl = ''
    this.annotationCount = $(".annotation", this.el).length
    this.init()
  }

  init() {
    const start = (window.outerWidth < 1024)?'top 66%':'top center'
    const end = (window.outerWidth < 1024)?'bottom 66%':'bottom center'
    $(".annotation", this.el).each((i,el) => {
      ScrollTrigger.create({
        trigger: el,
        start: start,
        end: end,
        onEnter: ({trigger}) => this.enterAnnotation(trigger),
        onEnterBack: ({trigger}) => this.enterAnnotation(trigger), 
        onLeave: ({trigger}) => this.leaveAnnotation(trigger, 'forward'),
        onLeaveBack: ({trigger}) => this.leaveAnnotation(trigger, 'back'), 
        //markers: true
      })
    })
  }


  enterAnnotation(annotation) {
    const videoUrl = $(annotation).data('video')
    if (videoUrl !== undefined && videoUrl !== this.currentVideoUrl) {
      this.video.pause()
      $(this.video).fadeOut(200, ()=> {
        this.video.src = videoUrl
        this.currentVideoUrl = videoUrl
        this.video.load()
        $(this.video).fadeIn(200, ()=> {
          this.video.playbackRate = 0.5
          this.video.play()
        })
      })
    }
  }

  leaveAnnotation(annotation, direction) {
    const index = $(annotation).index()
    if (direction === 'back' && index === 0) {
      this.video.pause()
      this.currentVideoUrl = ''
    }
    if (direction === 'forward' && index + 1 === this.annotationCount) {
      this.video.pause()
      this.currentVideoUrl = ''
    }
  }
}